const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRightIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.31295 13.0203C5.13544 12.8428 5.1193 12.565 5.26454 12.3693L5.31295 12.3132L9.62584 8.00008L5.31295 3.68697C5.13544 3.50946 5.1193 3.23168 5.26454 3.03594L5.31295 2.97986C5.49046 2.80235 5.76824 2.78621 5.96398 2.93145L6.02006 2.97986L10.6867 7.64653C10.8642 7.82404 10.8804 8.10181 10.7351 8.29756L10.6867 8.35363L6.02006 13.0203C5.8248 13.2156 5.50821 13.2156 5.31295 13.0203Z",
    fill: "white",
    fillOpacity: 0.5,
    style: {
      fill: "white",
      fillOpacity: 0.5
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightIcon);
export default __webpack_public_path__ + "static/media/arrow-right-icon.0bc185eba14f8ca175c9850464d35a35.svg";
export { ForwardRef as ReactComponent };